import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-screen place-items-center bg-offwhite px-8 text-center">
          <div>
            <p className="font-display text-4xl text-espresso">Something went wrong.</p>
            <p className="mt-3 text-sm text-taupe">Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
